import api from './api';
import { AmortizationScheduleDTO } from '../types/AmortizationSchedule';

export const amortizationService = {
  getCrvSchedule: (productId: string) =>
    api.get<AmortizationScheduleDTO>(`/amortization-schedule/crv/${productId}`),
  getPhSchedule: (productId: string) =>
    api.get<AmortizationScheduleDTO>(`/amortization-schedule/ph/${productId}`),
};
